import HttpClient from '@/http';

const getOfflineEventUploads = async ({ dealerId }) => {
    const params = {
        fields: [
            'valid_entries',
            'creation_time',
            'event_stats',
            'event_time_max',
            'event_time_min',
            'first_upload_time',
            'match_rate_approx',
            'matched_entries',
            'duplicate_entries',
            'upload_tag',
        ],
    };

    const { data } = await new HttpClient().get(
        `dealers/${dealerId}/graph-api/offline-event-set/offline_event_uploads`,
        params
    );

    return data;
};

export default getOfflineEventUploads;
